<template>
    <tr>
        <td>{{ $t(item.type) }}</td>
        <td>{{ item.description }}</td>
        <td class="t_right" :class="{ 'text-danger': item.value < 0 }">
            {{ item.value | pmlFormatCurrencyById(tenant.currency_id) }}
            <small class="show" v-if="tenant.currency_id !== quotation.currency_id">
                ({{ item.value * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
            </small>
        </td>
        <td class="t_center">
            <span class="btn btn-xs btn-warning" v-pml-tooltip="$t('edit')" @click.prevent="edit()"><i class="fa fa-pencil"></i></span>
            <span class="btn btn-xs btn-danger" v-pml-tooltip="$t('delete')" @click.prevent="destroy()" v-pml-block="isDeleting"><i class="fa fa-times"></i></span>
        </td>
    </tr>
</template>

<script>
    import bus from 'utils/events/bus'
    import Notify from 'utils/helpers/notify'
    import TableFilters from 'utils/mixins/table-filters'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { find } from 'lodash'
    import { destroy } from 'services/quotation-charges'

    export default {
        name: 'QuotationItemCharge',
        mixins: [ TableFilters ],
        props: [ 'item' ],
        data () {
            return {
                isDeleting: false
            }
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'quotations': 'getDealQuotations'
            }),
            quotation () {
                return find(this.quotations, {id: parseInt(this.$route.params.quotation)}) || {}
            }
        },
        methods: {
            edit () {
                bus.$emit('editCharge', this.item)
            },
            destroy () {
                this.isDeleting = true

                destroy(this.quotation.deal_id, this.quotation.id, this.item.id)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isDeleting = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/charges/Item.vue